import _ from 'lodash'
import vm from '../main'
import { API } from '../config'
import { httpClient as http } from '../services'

const internals = {}

internals.addDumpYard = function(dumpYard) {
  dumpYard = (({
    cityId,
    dumpYardName,
    // dumpYardLocation,
    contactNumber,
    user,
    // geoloc,
    _id
  }) => {
    return {
      cityId,
      dumpYardName,
      // dumpYardLocation,
      contactNumber,
      user,
      // geoloc,
      _id
    }
  })(dumpYard)

  return vm.$dumpyardDataRepository
    .create(dumpYard)
    .then(result => {
      dumpYard = result.data
      return dumpYard
    })
    .catch(error => {
      console.error('transportService.createRegion-error:\n', error)
      throw error
    })
}

internals.updateDumpYard = function(dumpYard) {
  dumpYard = Object.assign({}, dumpYard)
  dumpYard = (({
    cityId,
    dumpYardName,
    // dumpYardLocation,
    contactNumber,
    user,
    // geoloc,
    _id
  }) => {
    return {
      cityId,
      dumpYardName,
      // dumpYardLocation,
      contactNumber,
      user,
      // geoloc,
      _id
    }
  })(dumpYard)
  
  return vm.$dumpyardDataRepository
    .update(dumpYard._id, dumpYard)
    .then(result => {
      dumpYard = result.data
      return dumpYard
    })
    .catch(error => {
      console.error('transportUpdate.update-error:\n', error)
      throw error
    })
}

internals.updateDumpYardStatus = function(id, status) {
  return http.put(API.DUMPYARD + '/' + id + '/status' + '/' + status)
}


internals.dumpYardSearch = function(params,searchItem) {
  return http
    .get(`/datacity/search?page=${params.page}&limit=${params.limit}&searchString=${searchItem}`)
    .then(result => {
      return result
    })
    .catch(error => {
      console.error('authService.inviteUser-error:\n', error)
      throw error
    })
}

export default internals



// WEBPACK FOOTER //
// ./src/services/dumpyard.service.js